<template>
  <nav class="mira-nav" :class="{
    'mira-nav--solid': !isTransparent,
    'mira-nav--transparent': isTransparent,
  }">
    <div class="mira-nav__inner">
      <router-link to="/" class="mira-nav__brand">
        <img :src="logo" alt="Miraverse.ID" class="mira-nav__logo" />
        <span class="mira-nav__brand-text">Miraverse<span class="mira-nav__brand-accent">.ID</span></span>
      </router-link>

      <div class="mira-nav__links" :class="{ 'mira-nav__links--open': isMenuOpen }">
        <router-link to="/" class="mira-nav__link" @click.native="closeMenu">Home</router-link>
        <router-link to="/about" class="mira-nav__link" @click.native="closeMenu">Tentang Kami</router-link>
        <router-link to="/services" class="mira-nav__link" @click.native="closeMenu">Layanan</router-link>
        <router-link to="/projects" class="mira-nav__link" @click.native="closeMenu">Proyek</router-link>
        <router-link to="/contact" class="mira-nav__link mira-nav__link--cta" @click.native="closeMenu">
          Hubungi Kami
        </router-link>
      </div>

      <button class="mira-nav__hamburger" :class="{ 'mira-nav__hamburger--active': isMenuOpen }" @click="toggleMenu"
        aria-label="Toggle navigation">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- Mobile Overlay -->
    <div class="mira-nav__overlay" :class="{ 'mira-nav__overlay--visible': isMenuOpen }" @click="closeMenu"></div>
  </nav>
</template>

<script>
export default {
  name: "HeaderComponent",
  data() {
    return {
      isTransparent: true,
      isMenuOpen: false,
      logo: require("@/assets/images/logo-mira.png"),
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    $route() {
      this.closeMenu();
      window.scrollTo(0, 0);
    },
  },
  methods: {
    handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      this.isTransparent = scrollTop <= 50 && !this.isMenuOpen;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (this.isMenuOpen) {
        this.isTransparent = false;
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
        this.handleScroll();
      }
    },
    closeMenu() {
      this.isMenuOpen = false;
      document.body.style.overflow = "";
      this.handleScroll();
    },
  },
};
</script>

<style scoped lang="scss">
.mira-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.35s ease;
  padding: 0 24px;
}

.mira-nav--transparent {
  background: transparent;
}

.mira-nav--solid {
  background: rgba(26, 10, 46, 0.97);
  backdrop-filter: blur(12px);
  box-shadow: 0 2px 20px rgba(26, 10, 46, 0.3);
}

.mira-nav__inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
}

.mira-nav__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  z-index: 1001;
}

.mira-nav__logo {
  height: 42px;
  width: auto;
}

.mira-nav__brand-text {
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 1.2rem;
  font-weight: 700;
  color: #fff;
}

.mira-nav__brand-accent {
  color: #c73468;
}

.mira-nav__links {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mira-nav__link {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.92rem;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.25s ease;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.08);
  }

  &.router-link-exact-active {
    color: #c73468;
  }
}

.mira-nav__link--cta {
  background: linear-gradient(135deg, #6c2973, #c73468);
  color: #fff !important;
  padding: 10px 24px;
  border-radius: 50px;
  font-weight: 600;
  margin-left: 8px;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 20px rgba(199, 52, 104, 0.4);
    background: linear-gradient(135deg, #6c2973, #c73468);
  }
}

// Hamburger
.mira-nav__hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  z-index: 1001;
  border-radius: 8px;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  span {
    width: 24px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
    transition: all 0.3s ease;
  }

  &--active {
    span:nth-child(1) {
      transform: rotate(45deg) translate(5px, 5px);
    }

    span:nth-child(2) {
      opacity: 0;
    }

    span:nth-child(3) {
      transform: rotate(-45deg) translate(5px, -5px);
    }
  }
}

// Overlay
.mira-nav__overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: 0;
  transition: opacity 0.3s ease;

  &--visible {
    opacity: 1;
  }
}

@media (max-width: 991px) {
  .mira-nav__hamburger {
    display: flex;
  }

  .mira-nav__overlay {
    display: block;
    pointer-events: none;

    &--visible {
      pointer-events: auto;
    }
  }

  .mira-nav__links {
    position: fixed;
    top: 0;
    right: -320px;
    width: 300px;
    height: 100vh;
    background: #1a0a2e;
    flex-direction: column;
    align-items: flex-start;
    padding: 100px 32px 32px;
    gap: 4px;
    transition: right 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1000;
    box-shadow: -8px 0 30px rgba(0, 0, 0, 0.3);

    &--open {
      right: 0;
    }
  }

  .mira-nav__link {
    width: 100%;
    padding: 14px 16px;
    font-size: 1rem;
    border-radius: 10px;
  }

  .mira-nav__link--cta {
    margin-left: 0;
    margin-top: 16px;
    text-align: center;
    justify-content: center;
    display: flex;
  }
}
</style>
